<template>
  <div
    v-if="locations && locations.length > 0"
    class="message-container"
    :class="{
      'pl-4 pr-5': !isMobile,
    }"
  >
    <div
      :class="{
        'pr-5': isMobile
      }"
    >
      <webtotext-dialog
        v-if="!$isMultiChannelEnabled"
        v-model="showDialog"
        @openMessageFormEvent="openMessageFormEvent"
      />
    </div>
    <webtotext-form
      v-show="showForm"
      @closeForm="closeForm"
    />
    <div
      v-show="(!showForm && isMobile) || !isMobile"
      class="text-right pb-5 mt-3"
      :class="{
        'px-5': isMobile
      }"
    >
      <webtotext-chat-button
        v-if="!showForm"
        :show-form="showForm"
        @closeDialogChatEvent="closeDialogChatEvent"
      />
    </div>
  </div>
</template>

<script>
import WebToTextDialog from '@/components/webToTextDialog/WebToTextDialog.vue'
import WebToTextChatButton from '@/components/webToTextChatButton/WebToTextChatButton.vue'
import WebToTextForm from '@/components/webToTextForm/WebToTextForm.vue'
import { WebToTextConstants } from '@/constants'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'WebToTextView',
  components: {
    'webtotext-dialog': WebToTextDialog,
    'webtotext-chat-button': WebToTextChatButton,
    'webtotext-form': WebToTextForm
  },
  props: {},
  data () {
    return {
      showDialog: false,
      showForm: false
    }
  },
  computed: {
    ...mapState({
      locations: 'locations',
      isMobile: 'isMobile'
    })
  },
  async mounted () {
    this.showForm = this.$isMultiChannelEnabled
    this.getLocationsWithMessaging(this.$practiceUuid)
  },
  methods: {
    ...mapActions({
      getLocationsWithMessaging: 'getLocationsWithMessaging'
    }),
    closeDialogChatEvent () {
      this.showForm = !this.showForm
      this.showDialog = false
    },
    closeForm () {
      if (this.$isMultiChannelEnabled) {
        window.parent.postMessage(
          { type: WebToTextConstants.WIDGET_HIDE_EVENT, payload: { widgetId: WebToTextConstants.WIDGET_ID } },
          { targetOrigin: this.$originHost }
        )
        return
      }

      this.showForm = false
    },
    openMessageFormEvent () {
      this.showForm = true
    }
  }
}

</script>
